<template>
  <div class="" v-if="isUserThisPlanner || (!isUserThisPlanner && planner != null)">

    <template v-if="!isUserThisPlanner">
      &nbsp;&nbsp;&nbsp;
      <router-link :to="{ name: 'planner-list' }" tag="a" class="no-underline inline-block hover:underline mb-4 text-sm text-black">Back to planner list</router-link>
    </template>

    <div class="nav-box">

      <div class="nav-box-header">
        <template v-if="isUserThisPlanner">
          My Account
        </template>

        <template v-else>
          {{ planner.first_name }} {{ planner.last_name }}
        </template>
      </div>

      <router-link
        :to="{
          name: 'planner-account',
          params : {
            plannerId : $route.params.plannerId
          }
        }"
        tag="a"
        :class="{ 'nav-item mt-1' : true, 'selected' : $route.name == 'planner-account' }">
        <template v-if="isUserThisPlanner">
          My Details
        </template>

        <template v-else>
          Planner Details
        </template>
      </router-link>

      <router-link
        :to="{
          name  : 'planner-password',
          params: {
            plannerId : $route.params.plannerId
          }
        }"
        tag="a"
        :class="{ 'nav-item' : true, 'selected' : $route.name == 'planner-password' }">Password</router-link>

      <router-link
        :to="{
          name  : 'planner-site-appearance',
          params: {
            plannerId : $route.params.plannerId
          }
        }"
        tag="a"        
        :class="{ 'nav-item' : true, 'selected' : $route.name == 'planner-site-appearance' }">Site Appearance</router-link>

      <router-link
        :to="{
          name: 'planner-mail-setting',
          params: {
            plannerId: $route.params.plannerId
          }
        }"
        tag="a"
        :class="{ 'nav-item' : true, 'selected' : $route.name == 'planner-mail-setting' }">Mail Settings</router-link>

      <!-- planner payment can only be done by the planner 
      <template v-if="$store.state[$store.state.view + 'Module'].planner.user_id == $store.state.user.id">
        <router-link
          :to="{
            name  : 'planner-payment',
            params: {
              plannerId : $route.params.plannerId
            }
          }"
          tag="a"
          :class="{ 'nav-item' : true, 'selected' : $route.name == 'planner-payment' }">Payment Details</router-link>
      </template>
      -->
    </div>
  </div>
</template>

<script>
	import axios          from "axios";

  export default {

    data() {
      return {
        planner : null
      }
    },

    created() {
      if(!this.isUserThisPlanner) {
				var params = {
					plannerId : this.$route.params.plannerId
				};
        this.showLoader("Getting data...")
				 axios.get(process.env.VUE_APP_API_URL + '/api/planner/detail', {
          params,
          headers: {
            'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
          }
        }).then(response => {
					this.planner = response.data;
          // // only commit if the planner is same as the current planner
          // if((this.$store.state.view == 'planner' && this.$store.state.user.id == response.data.user_id) || this.$store.state.view == 'client') {
          //   this.$store.commit(this.$store.state.view + "Module/setPlanner", response.data)
          // }

          // callback(response.data)
        })
        // this.getPlanner({
        //   plannerId: this.$route.params.plannerId,
        //   force   : true
        // }, (planner) => {
        //   this.hideLoader()
        //   this.planner = planner
        // })
      }
    },
  }
</script>